import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/button";
import Loader from "../../components/loader";
import { openPopUp } from "../../components/popUp";
import { useSafeNavigate } from "../../components/unloadBlocker";
import { useDashboardContext } from "../../context/dashboardContext";
import { OverviewResponseDTO } from "../../openapi-generated-client";
import AddAccountCreditSuccessPopUp from "../../pageparts/popup/addAccountCreditSuccessPopUp";
import AddCreditPopUp from "../../pageparts/popup/addCreditPopUp";
import PayOutPopUp from "../../pageparts/popup/payOutPopUp";
import PurchaseCancelPopUp from "../../pageparts/popup/purchaseCancelPopUp";
import { formatPrice } from "../../utils/priceUtils";

interface DashboardOverviewPageProps {
    purchaseSuccess?: boolean;
}

export default function DashboardOverviewPage(props: DashboardOverviewPageProps) {

    const navigate = useSafeNavigate(useNavigate());

    const {appContext, sessionId} = useDashboardContext();
    const { overviewController } = appContext;

    const [data, setData] = useState<OverviewResponseDTO>();

    async function fetchData() {
        setData((await overviewController.getOverview(sessionId)).data);
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if(props.purchaseSuccess != undefined) {
            if(props.purchaseSuccess) {
                openPopUp(<AddAccountCreditSuccessPopUp refetch={fetchData}/>);
                navigate("/dashboard/overview");
            }else {
                openPopUp(<PurchaseCancelPopUp/>);
                navigate("/dashboard/overview");
            }
        }
    }, [props.purchaseSuccess]);

    if(!data) return <Loader/>;

    return  <div className="bottom-margin overview">
        <div className="inner-page">
            <div className="balance">
                <hr/>
                <h2>Account Balance</h2>
                <div className="balance-value">
                    <a className="money">{formatPrice(data.balance)}<span>€</span></a>
                    {data.canPayout ? <Button disabled={data.balance < 10} onClick={() => {
                        if(data.balance < 10) {
                            return;
                        }
                        openPopUp(<PayOutPopUp />);
                    }}>Pay out</Button> : <></>}
                    <Button onClick={() => {
                        openPopUp(<AddCreditPopUp />);
                    }}>Add credit</Button>
                </div>
            </div>
        </div>
    </div>;
}